/**
 * A value that settles before it is used.
 *
 * Every search box over a large list needs this. The article list is 32 086
 * rows behind a trigram search and the customer list is 10 552; somebody
 * typing fires one request per keystroke, most of them wasted work on the
 * server and any of them able to arrive out of order.
 *
 * It is half of the fix. `useResource` supplies the other half — a response
 * from a superseded request is discarded — and neither is sufficient alone:
 * debouncing reduces the number of requests, and only supersession guarantees
 * the one that lands is the one that matches what is on screen.
 */

import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
